import {createStateMaker} from '@shared/helpers/object'

import {AdditionalOptionState} from '../interfaces'

export const getInitialState = (): AdditionalOptionState => ({
    enabled: false,
    inputOptions: [],
    selectOptions: [],
    selected: {
        individuallyInput: [],
        particularInputByItemId: {},
        isParticularInput: false,
    },
})

export const makeMock = createStateMaker<AdditionalOptionState>(getInitialState)
